import { render, staticRenderFns } from "./StepInformation.vue?vue&type=template&id=2770b942&"
import script from "./StepInformation.vue?vue&type=script&lang=js&"
export * from "./StepInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2770b942')) {
      api.createRecord('2770b942', component.options)
    } else {
      api.reload('2770b942', component.options)
    }
    module.hot.accept("./StepInformation.vue?vue&type=template&id=2770b942&", function () {
      api.rerender('2770b942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/oficialNumeration/StepInformation.vue"
export default component.exports